import { defineComponent as _defineComponent } from 'vue'
import { useExpandedPostStore } from '@@/pinia/expanded_post'
import { calculateSizeToFitElementInWrapper } from '@@/bits/attachments'
import window from '@@/bits/global'
import initPinchZoom from '@@/bits/pinchzoom'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import { debounce } from 'lodash-es'
import { computed, watch, ref, nextTick, onMounted, onBeforeUnmount } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePanelPostExpandedAttachmentImage',
  props: {
    url: null,
    originalImageUrl: null,
    originalImageWidth: null,
    originalImageHeight: null,
    title: null
  },
  emits: ["load", "error", "resize"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'load'): void
  (name: 'error'): void
  (name: 'resize', dimensions: { width: number; height: number }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  url: string
  originalImageUrl: string
  originalImageWidth: number
  originalImageHeight: number
  title: string
}





const width = ref(0)
const height = ref(0)
const aspectRatio = ref(0)
const xBorderRadius = ref(false)
const container = ref<HTMLDivElement>()

const expandedPostStore = useExpandedPostStore()
const xExpandedPostTextPanel = computed(() => expandedPostStore.xExpandedPostTextPanel)

const setImageSize = () => {
  nextTick(() => {
    if (!container.value) return
    const element = {
      width: props.originalImageWidth,
      height: props.originalImageHeight,
      aspectRatio: props.originalImageWidth / props.originalImageHeight,
    }
    const wrapper = {
      width: container.value.offsetWidth,
      height: container.value.offsetHeight,
    }
    const {
      width: calculatedWidth,
      height: calculatedHeight,
      isTouchingHorizontally,
      isTouchingVertically,
    } = calculateSizeToFitElementInWrapper(element, wrapper)
    width.value = calculatedWidth
    height.value = calculatedHeight
    aspectRatio.value = element.aspectRatio
    xBorderRadius.value = !isTouchingHorizontally && !isTouchingVertically
    emit('resize', { width: width.value, height: height.value })
  })
}

const debouncedSetImageSize = debounce(() => {
  if (window.visualViewport && window.visualViewport.scale > 1) {
    // When the content is pinch-zoomed, prevented any resizing and recalculation.
    // This is also done in other SurfacePanelPostExpandedAttachment[Type].vue components
    return
  }
  setImageSize()
}, 250)

watch(xExpandedPostTextPanel, () => {
  setImageSize()
})

let deinitPinchZoom: (() => void) | null = null
onMounted(() => {
  setImageSize()
  nextTick(() => {
    if (!container.value) return
    deinitPinchZoom = initPinchZoom(container.value)
  })
  window.addEventListener('resize', debouncedSetImageSize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', debouncedSetImageSize)
  if (deinitPinchZoom) {
    deinitPinchZoom()
  }
})

return { __sfc: true,emit, props, width, height, aspectRatio, xBorderRadius, container, expandedPostStore, xExpandedPostTextPanel, setImageSize, debouncedSetImageSize, deinitPinchZoom, ImageThumbnail }
}

})